import { makeStyles } from "@material-ui/core";

const pxToRem = (px: number) => `${px / 16}rem`;

export const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
  },
  root: {
    display: "flex",
    maxWidth: "18.25rem",
    background: theme.palette.common.white,
    paddingBottom: "10px",
    boxShadow: `0 0 10px ${theme.palette.grey[300]}`,
    flexDirection: "column",
    alignItems: "center",
  },
  calendar__input: {
    position: "relative",
    width: "100%",
  },
  calendar: {
    position: "absolute",
    zIndex: 10,
    fontSize: pxToRem(14),
    fontFamily: theme.typography.fontFamily,
    boxShadow: `0 0 10px ${theme.palette.grey[300]}`,
    borderRadius: "1%",
    width: pxToRem(290),
    [`& .rdrNextPrevButton`]: {
      display: "none !important",
    },
    [`& .rdrMonthAndYearPickers`]: {
      justifyContent: "flex-start",
    },
    [`& .rdrWeekDays`]: {
      textTransform: "uppercase",
      fontSize: pxToRem(12),
    },
    [`& .rdrMonth`]: {
      width: pxToRem(260),
    },
    [`& .rdrDayToday .rdrDayNumber span:after`]: {
      content: "none",
    },
    [`& .rdrInRange`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span`]: {
      color: theme.palette.common.black,
    },
    [`& .rdrStartEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDay:.rdrStartEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrEndEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDayNumber`]: {
      display: "flex",
      top: "0",
      bottom: "0",
    },
    [`& .rdrStartEdge ~ .rdrDayNumber`]: {
      display: "flex",
      height: pxToRem(36),
      width: pxToRem(37),
      top: "0",
      bottom: "0",
      borderRadius: "50%",
      background: theme.palette.primary.main,
    },
    [`& .rdrEndEdge ~ .rdrDayNumber`]: {
      display: "flex",
      height: pxToRem(36),
      width: pxToRem(37),
      top: "0",
      bottom: "0",
      borderRadius: "50%",
      background: theme.palette.primary.main,
    },
    [`& .rdrSelected, .rdrInRange, .rdrStartEdge, .rdrEndEdge`]: {
      top: pxToRem(3),
      bottom: pxToRem(3),
    },
    [`& .rdrYearPicker ~ select`]: {
      height: pxToRem(20),
    },
  },
  calendarPicker: {
    top: 0,
    bottom: 0,
    zIndex: 10,
    fontSize: pxToRem(14),
    fontFamily: theme.typography.fontFamily,
    borderRadius: "1%",
    width: pxToRem(290),
    [`& .rdrWeekDays`]: {
      textTransform: "uppercase",
      fontSize: pxToRem(12),
    },
    [`& .rdrMonth`]: {
      width: pxToRem(260),
      paddingBottom: pxToRem(5),
    },
    [`& .rdrDayToday .rdrDayNumber span:after`]: {
      content: "none",
    },
    [`& .rdrInRange`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span`]: {
      color: theme.palette.common.black,
    },
    [`& .rdrStartEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDay:.rdrStartEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrEndEdge`]: {
      background: "#F1F6FC",
    },
    [`& .rdrDayNumber`]: {
      display: "flex",
      top: "0",
      bottom: "0",
    },
    [`& .rdrStartEdge ~ .rdrDayNumber`]: {
      display: "flex",
      height: pxToRem(36),
      width: pxToRem(37),
      top: "0",
      bottom: "0",
      borderRadius: "50%",
      background: theme.palette.primary.main,
    },
    [`& .rdrEndEdge ~ .rdrDayNumber`]: {
      display: "flex",
      height: pxToRem(36),
      width: pxToRem(37),
      top: "0",
      bottom: "0",
      borderRadius: "50%",
      background: theme.palette.primary.main,
    },
    [`& .rdrSelected, .rdrInRange, .rdrStartEdge, .rdrEndEdge`]: {
      top: pxToRem(3),
      bottom: pxToRem(3),
    },
    [`& .rdrYearPicker ~ select`]: {
      height: pxToRem(20),
    },
    [`& rdrMonthsVertical`]: {
      alignItems: "center",
    },
  },
  definedRange: {
    width: pxToRem(170),
    maxHeight: 250,
    overflowY: "scroll",
  },
}));
